// extracted by mini-css-extract-plugin
export var bubble = "_1e-0";
export var container = "_1e-f";
export var contrastBorder = "_1e-g";
export var greyOut = "_1e-2";
export var initialsColor0 = "_1e-3";
export var initialsColor1 = "_1e-4";
export var initialsColor10 = "_1e-d";
export var initialsColor11 = "_1e-e";
export var initialsColor2 = "_1e-5";
export var initialsColor3 = "_1e-6";
export var initialsColor4 = "_1e-7";
export var initialsColor5 = "_1e-8";
export var initialsColor6 = "_1e-9";
export var initialsColor7 = "_1e-a";
export var initialsColor8 = "_1e-b";
export var initialsColor9 = "_1e-c";
export var initialsWrapper = "_1e-1";
export var large = "_1e-l";
export var medium = "_1e-k";
export var mediumSmall = "_1e-j";
export var mediumSmallMedium = "_1e-o";
export var micro = "_1e-h";
export var small = "_1e-i";
export var tiny = "_1e-n";
export var xTiny = "_1e-m";